import { ICellRendererParams, IRowDragItem } from "ag-grid-community";
import { CellLinkComponent } from "../core/table/cell-link.component";

export const locationColumns = [
  {
    headerName: "Facility",
    field: "facilityname",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
  },
  {
    headerName: "Region",
    field: "levelname",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    editable: false,
  },
  {
    headerName: "Area",
    field: "parentlevelname",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    editable: false,
  },
  {
    headerName: "Division",
    field: "parentofparentlevelname",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    editable: false,
  },
];

export const rowDragText: (
  params: IRowDragItem,
  dragItemCount: number
) => string = function (params: IRowDragItem) {
  return params.rowNode?.data.facilityname;
};

export const corporationColumns = [
  {
    headerName: "ID",
    field: "id",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    editable: false,
    rowDrag: true,
  },
  {
    headerName: "Facility",
    field: "facilityname",
    cellRenderer: CellLinkComponent,
    cellRendererParams: {
      route: "facility",
      property: "id",
      rootUrl: true,
      queryParams: { prev: "corporation" },
    },
  },
  {
    headerName: "Address",
    field: "address",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    editable: false,
  },

  {
    headerName: "Status",
    field: "status",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    editable: false,
  },
];

export const closeOutColumns = [
  {
    headerName: "Facility",
    field: "facilityname",
    cellRenderer: CellLinkComponent,
    cellRendererParams: {
      route: "facility",
      property: "id",
      rootUrl: true,
      queryParams: { prev: "corporation" },
    },
  },
  {
    headerName: "ID",
    field: "id",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    editable: false,
    rowDrag: true,
  },
  {
    headerName: "Address",
    field: "address",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    editable: false,
  },
];
